module.exports = __webpack_public_path__ + "media/logos/slack-eaae42d7.png";